

















































































/* eslint-disable */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import dayjs from 'dayjs';

import Checkbox from '@/components/Checkbox.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';

import api from '@/libs/api';
import format from '@/libs/numberFormat';
import { AxiosError } from 'axios';
@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    Checkbox,
    ActionPopup,
  },
  methods: {
    format,
  },
})
export default class ReconmerchantTable extends Vue {
  loading = true;
  listReconMerchant: any[] = [];

  merchantLoginData: any = this.$store.state.user.user.merchant;

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;
  selected: { [id_reconcilation: string]: any } = {};

  format!: typeof format;

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString() },
    });
  }

  openDetail(itemData: any) {
    // console.log('item', itemData);
    // window.open(`/account-management/edit/${id}`, '_blank');
    if (this.merchantLoginData) {
      this.$router.push(`/billing/recon-data/merchant/${itemData.merchant_code}/${itemData.credential_code}/${itemData.periode_slug}`);
    } else {
      this.$router.push(`/billing/recon-data/internal/${itemData.merchant_code}/${itemData.credential_code}/${itemData.periode_slug}`);
    }
    // alert(periode_slug);
  }

  async getListData(params: any, page = 1, isExport: boolean) {
    try {

      const parameter: any = {
        page,
      };
      for (const key in params) {
        if ((params[key] || params[key] == '0') && params[key] != 'Invalid Date') {
          parameter[key] = params[key];
        }
      }
      let exportParameter: any = { ...parameter }
      delete exportParameter.page;
      delete exportParameter.limit;

      if (isExport) {
        await api.get('recon/traffic/list/export', {
          params: exportParameter,
          responseType: "arraybuffer"
        }).then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data])
          );
          let link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `List_Traffic_Recon.xlsx`);
          document.body.appendChild(link);
          link.click();
        })
      } else {
        this.loading = true;
        const { data } = await api.get('/recon/traffic', {
          params: parameter,
        });

        // console.log(data.data.last_page);
        this.page = page;
        this.listReconMerchant = data.data.data;
        this.totalPage = data.data.last_page;
        this.from = data.data.from;
        this.to = data.data.to;
        this.totalItem = data.data.total;
        this.loading = false;
      }

      return null;
    } catch (err) {
      return err as AxiosError;
    }
  }

  selectRow(listReconMerchant: any) {
    if (this.isSelected(listReconMerchant.id_reconcilation)) {
      this.$delete(this.selected, listReconMerchant.id_reconcilation);
    } else {
      this.$set(this.selected, listReconMerchant.id_reconcilation, listReconMerchant);
    }

    this.$emit('select-change', Object.keys(this.selected).length);
  }

  isSelected(id_reconcilation: number) {
    return this.selected[id_reconcilation] !== undefined;
  }

  get isAllChecked() {
    return this.listReconMerchant.every((e) => this.selected[e.id_reconcilation] !== undefined);
    // return true;
  }

  checkAll(checked: boolean) {
    if (checked) {
      this.listReconMerchant.forEach((e) => {
        this.$set(this.selected, e.id_reconcilation, e);
      });
    } else {
      this.listReconMerchant.forEach((e) => {
        this.$delete(this.selected, e.id_reconcilation);
      });
    }

    this.$emit('select-change', Object.keys(this.selected).length);
  }

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
    if (formatted === 'Invalid Date') {
      return '-';
    }
    return formatted;
  }

  // eslint-disable-next-line class-methods-use-this
  periodFormat(time: string) {
    const formatted = dayjs(time, 'MM-YYYY').format('MMMM YYYY');
    if (formatted === 'Invalid Date') {
      return '-';
    }
    return formatted;
  }

  displayAction(status: number) {
    try {
      if (this.merchantLoginData) {
        if (status === 0 || status === 5) {
          return true;
        }
      } else {
        if ([0, 1, 4, 5].includes(status)) {
          return true;
        }
      }
      return false;
    } catch (error) {
      console.log(error);
      return false;
    }
  }
}
